import React from 'react';
import { Panel } from 'primereact/panel';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import RespondentInformation from './RespondentInformation';
import AccountInformation from './AccountInformation';
import Disclaimer from './Disclaimer';


const AccountAndRespondentInformation = ({ accountData, respondentData }) => (
  <Panel
    header={(
      <FormattedMessage
        id="menu.account-and-respondent-information"
        defaultMessage="Account and Respondent information"
      />
          )}
  >
    <div className="panel-body">
      <AccountInformation accountData={accountData} />
      <RespondentInformation respondentInformation={respondentData} />
      <Disclaimer />
    </div>
  </Panel>
);

AccountAndRespondentInformation.propTypes = {
  accountData: PropTypes.objectOf(PropTypes.any).isRequired,
  respondentData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AccountAndRespondentInformation;
